import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  effect,
  inject,
  signal,
  type OnInit,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { PROVINCES, REGIONS } from '@constants/settings.constant';
import { handlerApiError, toastSuccess } from '@helpers/function.helper';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { finalize, map, of, switchMap } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NO_PERMISSIONS } from '@models/users.model';

@Component({
  selector: 'market-region-form-dialog',
  standalone: true,
  imports: [FormsModule, ConfirmDialogComponent, NgxPermissionsModule],
  templateUrl: './region-form-dialog.component.html',
  styleUrl: './region-form-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionFormDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;
  @ViewChild(ConfirmDialogComponent) confirmDialog!: ConfirmDialogComponent;

  private userService = inject(UserService);
  private authService = inject(AuthService);

  userInfo = this.authService.userInfo;
  loading = signal(false);

  constructor() {
    effect(() => {
      if (!this.userInfo().region) {
        setTimeout(() => {
          this.showModal();
        }, 100);
      }
    });
  }

  get regions() {
    return REGIONS;
  }

  get provinces() {
    return PROVINCES;
  }

  get guest() {
    return NO_PERMISSIONS;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  dialogCloseHandler() {
    if (!this.userInfo().region) {
      this.showModal();
    }
  }

  showModal() {
    if (this.dialog?.nativeElement) {
      this.dialog.nativeElement.show();
    }
  }

  submitHandler(ngForm: NgForm) {
    ngForm.form.markAllAsTouched();
    if (ngForm.invalid) return;
    const ref = this.confirmDialog
      .showModal()
      .pipe(
        switchMap(confirm => {
          if (!confirm) return of(false);
          this.loading.set(true);
          return this.userService.updateRegion(ngForm.value).pipe(
            map(() => true),
            finalize(() => this.loading.set(false))
          );
        })
      )
      .subscribe({
        next: async res => {
          if (res) {
            await this.authService.getUserInfo();
            this.dialog.nativeElement.close();
            toastSuccess('Cập nhật thành công');
          }
          ref.unsubscribe();
        },
        error: err => handlerApiError(err, 'Cập nhật khu vực thất bại'),
      });
  }
}
